import * as React from "react";
import type { SVGProps } from "react";
const SvgCableTvIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14.528 2.8c-.435 0-.863.102-1.251.296L9.579 4.945c-.378.189-.619.578-.619 1v.215h-2.8a5.05 5.05 0 0 0-5.04 5.04 5.05 5.05 0 0 0 5.04 5.04h15.68a3.91 3.91 0 0 1 3.92 3.92 3.91 3.91 0 0 1-3.92 3.92H1.12v1.12h20.72a5.05 5.05 0 0 0 5.04-5.04 5.05 5.05 0 0 0-5.04-5.04H6.16a3.91 3.91 0 0 1-3.92-3.92 3.91 3.91 0 0 1 3.92-3.92h2.8v.214c0 .423.241.812.618 1.001v.001l3.699 1.849c.388.193.816.295 1.251.295h6.402c.498 0 .91-.412.91-.91V8.4h3.36c.921 0 1.68-.759 1.68-1.68s-.759-1.68-1.68-1.68h-3.36V3.702a.91.91 0 0 0-.902-.902zm0 1.12h2.832v5.596h1.12V3.92h2.24v5.6h-6.192c-.26 0-.517-.06-.751-.177L10.08 7.494h-.001V5.947l3.698-1.85c.233-.117.49-.177.75-.177m7.312 2.24h3.36c.316 0 .56.244.56.56s-.244.56-.56.56h-3.36z"
    />
  </svg>
);
export default SvgCableTvIcon;
